import React, { useState } from 'react';
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
} from "reactstrap";
const DeleteButton = ({ url }) => {
    const token = localStorage.getItem("auth_token");
    const [showModal, setShowModal] = useState(false);
    const toggleModal = () => setShowModal(!showModal);

    const handleDelete = async () => {
        try {
            const response = await fetch(url, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.ok) {
                // Handle success, e.g., reload page or update UI
                window.location.reload(); // Example: reload the page
            } else {
                // Handle error
                toast.error(response.error);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    return (
        <React.Fragment>
            <button
                className="btn btn-sm btn-soft-danger"
                onClick={() => setShowModal(true)}
            >
                <i className="mdi mdi-delete-outline"></i>
            </button>

            <Modal isOpen={showModal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                    Action
                </ModalHeader>
                <ModalBody>
                    <p>Êtes-vous sûr de vouloir supprimer cet enregistrement?</p>
                </ModalBody>
                <ModalFooter>
                    <Button
                        style={{ backgroundColor: "#3c88c8" }}
                        onClick={() => {
                            handleDelete(), toggleModal();
                        }}
                    >
                        Valider
                    </Button>
                    <Button color="secondary" onClick={toggleModal}>
                        Fermer
                    </Button>
                </ModalFooter>
            </Modal>
            <ToastContainer />
        </React.Fragment>
    );
};

export default DeleteButton;